
const digest = '68bfda34b511f3795c39addabc4f59ad4dc1fc188e3b008315416468f5617b83';
const classes = {"wrapper":"_wrapper_rcmxq_1","childrenWrapper":"_childrenWrapper_rcmxq_7","item":"_item_rcmxq_14","content":"_content_rcmxq_36","label":"_label_rcmxq_44","subtitle":"_subtitle_rcmxq_48","control":"_control_rcmxq_53","caseType":"_caseType_rcmxq_58","mainFolder":"_mainFolder_rcmxq_61"};
const css = `._wrapper_rcmxq_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_rcmxq_1 ._childrenWrapper_rcmxq_7 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 20px;
  margin-left: 35px;
}
._wrapper_rcmxq_1 ._childrenWrapper_rcmxq_7 ._item_rcmxq_14:before {
  content: "";
  height: 55%;
  width: 15px;
  border-left: 1px solid #c6c6c6;
  border-bottom: 1px solid #c6c6c6;
  position: absolute;
  left: -20px;
  top: 0;
}
._wrapper_rcmxq_1 ._item_rcmxq_14 {
  padding: 12px;
  background-color: #ffffff;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_rcmxq_1 ._item_rcmxq_14 ._content_rcmxq_36 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex: 1;
  align-items: flex-start;
  padding: 12px;
}
._wrapper_rcmxq_1 ._item_rcmxq_14 ._content_rcmxq_36 ._label_rcmxq_44 {
  display: flex;
  flex-direction: column;
}
._wrapper_rcmxq_1 ._item_rcmxq_14 ._content_rcmxq_36 ._label_rcmxq_44 ._subtitle_rcmxq_48 {
  font-size: 12px;
  font-weight: 500;
  color: #d81616;
}
._wrapper_rcmxq_1 ._item_rcmxq_14 ._control_rcmxq_53 {
  display: flex;
  align-items: center;
  padding-right: 12px;
}
._wrapper_rcmxq_1 ._item_rcmxq_14._caseType_rcmxq_58 {
  color: #1665d8;
}
._wrapper_rcmxq_1 ._item_rcmxq_14._mainFolder_rcmxq_61 {
  background-color: #fbfbfd;
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  